import * as React from "react";
import styled from "styled-components";
import Constant from "utils/isomorphismConstant";
import EmptyPage from "./components/EmptyPage";
import resizer from "utils/browser/resizer";
import { Platform } from "utils/website";
import { isLocalDevelop, isUAT } from "utils/debug";
import { onChangeHeaderLang } from "utils/lang";

import MegatronFrontForMobile from "./pages/modules/index";
import { HomeProps } from "../index";
import { MWebHeader as MobileHeader } from "litb-header";

const MainContainer = styled.section`
	min-height: 600px;
	width: 100%;
	max-width: 100vw;

	/* 兼容iponeX */
	@supports (bottom: constant(safe-area-inset-bottom)) {
		padding-bottom: calc(3.0625rem + constant(safe-area-inset-bottom));
	}

	@supports (bottom: env(safe-area-inset-bottom)) {
		padding-bottom: calc(3.0625rem + env(safe-area-inset-bottom));
	}
`;

interface MobileState {
	hasDownloadBanner: boolean;
}

class Mobile extends React.Component<HomeProps, MobileState> {
	state: MobileState = {
		hasDownloadBanner: false,
	};

	constructor(props: HomeProps) {
		super(props);
	}
	componentDidMount() {
		resizer();
		window.addEventListener("resize", this.onResizeHandler);
	}

	onResizeHandler = () => {
		resizer();
	};

	render() {
		const { page, frontModules, tagQuery, runtime } = this.props;
		if (!page) {
			return <EmptyPage />;
		}
		return [
			<React.Fragment key={"MHEADER"}>
				{!runtime.isInApp && (
					<MobileHeader
						isUat={isUAT(runtime.hostname)}
						isDev={isLocalDevelop(runtime.hostname)}
						cookies={runtime.cookies || {}}
						runtime={{
							languageCode: Constant.language,
							currency: Constant.currency,
							countryCode: runtime.countryCode3,
							platform: Platform.MWEB,
							sid: runtime.sid,
						}}
						onChangeLanguage={onChangeHeaderLang}
					/>
				)}
			</React.Fragment>,
			<MainContainer
				key={"PAGE"}
				style={{
					backgroundColor:
						page && page.ui && page.ui.bgColor ? page.ui.bgColor : "#f7f7f7",
				}}>
				<MegatronFrontForMobile
					page={page}
					modules={frontModules}
					tagQuery={tagQuery}
					runtime={this.props.runtime}
				/>
			</MainContainer>,
		];
	}
}

export default Mobile;
